import React,{Fragment, PureComponent, } from 'react'
import PropTypes from 'prop-types';
import {Tooltip,} from "antd";

import Lang from "@/components/Lang/Lang";
import LogisticsInformation from '@components/Logistics/LogisticsInformation';
// import ToggleText from '@components/ToggleText/ToggleText';

/**
 * 查看 物流信息 (切换柜号 = > 改为显示两行 内外柜号)
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2022, all rights reserved. Essa.cn
 *
 * @showSimpleIcon 是否展示简单图标，否则展示带提示的物流图标
 * 示例 https://oss.essaone.com/16521e7c-fa6f-4cb7-bb32-fb6dc5861213.png
 **/
class LogisticsAndCabinetSwitch extends PureComponent {
    static propTypes = {
        logisticsData: PropTypes.array.isRequired,
        poCode: PropTypes.string,
        poId: PropTypes.any,
    }
    static defaultProps = {
        logisticsData: [],
        poCode:'',
        containerCode:'', // 内部柜号
        cabinetNum:'', // 外部柜号 物流柜号
        showContainerCode: true, // 是否显示内部柜号(集柜单号)
        poId:"",
        showPoOutInfo:true,//显示po物流出货信息 物流方式 物流LOGO 物流单号
    };
    onRefOne = (ref) =>  this.onChildLogisticsRef = ref;
    open() {
        if(this.onChildLogisticsRef)this.onChildLogisticsRef.openModalLogistics(true)
    };
    render() {
        const { logisticsData,poCode,cabinetNum,containerCode,showContainerCode, poId,showPoOutInfo }=this.props;
        return (<>
            {showContainerCode&&<div className={"logisticsLink"} onClick={()=>this.open(true)}>
            <Tooltip title={Lang({id: 'GuiHao',default:'柜号'})} placement="right">
                <i className="ri-archive-drawer-line font-14"></i>
                <span className={"icon_logistics_inline margin-left-5 black45"}>
                    {containerCode}
                </span>
            </Tooltip>
        </div>}
            <LogisticsInformation showSimpleIcon={true}
                                  poId={poId}
                                  onRef={this.onRefOne}
                                  // poCode={poCode}
                                  // leftCode={containerCode}
                                  // rightCode={cabinetNum}
                                  // showPoOutInfo={showPoOutInfo}
                                  // logisticsData={logisticsData}
            >
                    <Tooltip title={Lang({id: 'WuLiuGuiHao',default:'物流柜号'})} placement="right">
                        <span className={"icon_logistics_inline ri-truck-line font-14"}>
                            <span className={"margin-left-5 font-12 black45"}>{cabinetNum}</span>
                        </span>
                    </Tooltip>
                </LogisticsInformation>
            {/*<ToggleText text={containerCode} changeText={cabinetNum} />*/}
        </>);
    }
}

export default LogisticsAndCabinetSwitch;
